var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      class: { "footer-none": _vm.btns.length == 0 },
      attrs: {
        title: _vm.readonly ? "查看" : "编辑",
        width: "80%",
        destroyOnClose: ""
      },
      on: { cancel: _vm.close },
      model: {
        value: _vm.modalShow,
        callback: function($$v) {
          _vm.modalShow = $$v
        },
        expression: "modalShow"
      }
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          staticClass: "common-form-inline",
          attrs: {
            rules: _vm.ruleForm,
            model: _vm.pageData,
            "label-col": { span: 7 },
            "wrapper-col": { span: 13 }
          }
        },
        [
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "卖方名称", prop: "sellrName" } },
                    [_c("span", [_vm._v(_vm._s(_vm.pageData.sellrName))])]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      staticStyle: { "margin-bottom": "30px" },
                      attrs: { label: "发票上传", prop: "tblBlId" }
                    },
                    [
                      _c("imgUpload", {
                        staticStyle: { height: "110px" },
                        attrs: {
                          disabled: _vm.readonly,
                          file: _vm.pageData.file,
                          paramObj: _vm.uploadParam,
                          name: "file"
                        },
                        on: { remove: _vm.removeOk, uploadOk: _vm.uploadOk }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      staticStyle: { "margin-top": "-10px" },
                      attrs: { label: "发票类型", prop: "invoiceType" }
                    },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { allowClear: true, disabled: _vm.readonly },
                          on: { change: _vm.invTypeChange },
                          model: {
                            value: _vm.pageData.invoiceType,
                            callback: function($$v) {
                              _vm.$set(_vm.pageData, "invoiceType", $$v)
                            },
                            expression: "pageData.invoiceType"
                          }
                        },
                        _vm._l(_vm.invoiceTypes, function(item) {
                          return _c(
                            "a-select-option",
                            {
                              key: item.dctVal,
                              attrs: {
                                value: item.dctVal,
                                label: item.dctValNm
                              }
                            },
                            [_vm._v(_vm._s(item.dctValNm))]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _vm.pageData.invoiceType == 4
                    ? _c(
                        "a-form-model-item",
                        { attrs: { label: "发票代码" } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入", disabled: true },
                            model: {
                              value: _vm.pageData.invoiceCode,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "invoiceCode", $$v)
                              },
                              expression: "pageData.invoiceCode"
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "a-form-model-item",
                        { attrs: { label: "发票代码", prop: "invoiceCode" } },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "请输入",
                              disabled: _vm.readonly
                            },
                            model: {
                              value: _vm.pageData.invoiceCode,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "invoiceCode", $$v)
                              },
                              expression: "pageData.invoiceCode"
                            }
                          })
                        ],
                        1
                      )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "发票号码", prop: "invoiceNumber" } },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: "请输入",
                          disabled: _vm.readonly
                        },
                        model: {
                          value: _vm.pageData.invoiceNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "invoiceNumber", $$v)
                          },
                          expression: "pageData.invoiceNumber"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "开票日期", prop: "billTime" } },
                    [
                      _c("a-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请输入",
                          disabled: _vm.readonly,
                          valueFormat: "YYYY-MM-DD"
                        },
                        model: {
                          value: _vm.pageData.billTime,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "billTime", $$v)
                          },
                          expression: "pageData.billTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.pageData.invoiceType == 2 || _vm.pageData.invoiceType == 3
                ? _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "发票校验码后六位",
                            prop: "checkCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "请输入",
                              disabled: _vm.readonly
                            },
                            model: {
                              value: _vm.pageData.checkCode,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "checkCode", $$v)
                              },
                              expression: "pageData.checkCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pageData.invoiceType == 0 ||
              _vm.pageData.invoiceType == 1 ||
              _vm.pageData.invoiceType == 4
                ? _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "发票金额", prop: "invoiceAmount" } },
                        [
                          _c("a-input", {
                            staticClass: "myinput",
                            attrs: {
                              placeholder: "请输入",
                              type: "number",
                              disabled: _vm.readonly,
                              "addon-after": "(不含税)元"
                            },
                            model: {
                              value: _vm.pageData.invoiceAmount,
                              callback: function($$v) {
                                _vm.$set(_vm.pageData, "invoiceAmount", $$v)
                              },
                              expression: "pageData.invoiceAmount"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: { label: "发票金额", prop: "invoiceAmountWithVat" }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: "请输入",
                          type: "number",
                          disabled: _vm.readonly,
                          "addon-after": "(含税)元"
                        },
                        model: {
                          value: _vm.pageData.invoiceAmountWithVat,
                          callback: function($$v) {
                            _vm.$set(_vm.pageData, "invoiceAmountWithVat", $$v)
                          },
                          expression: "pageData.invoiceAmountWithVat"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "16px",
            "font-weight": "bold",
            "margin-bottom": "10px"
          }
        },
        [_vm._v("祺信列表")]
      ),
      _vm._v(" "),
      _c("a-table", {
        attrs: {
          pagination: false,
          columns: _vm.columns,
          "data-source": _vm.tableData,
          bordered: "",
          locale: { emptyText: "暂无数据" }
        },
        scopedSlots: _vm._u([
          {
            key: "gldId",
            fn: function(text, record) {
              return [_c("a", [_vm._v(_vm._s(text))])]
            }
          },
          {
            key: "gldAmt",
            fn: function(text, record) {
              return [_c("div", [_vm._v(_vm._s(text))])]
            }
          },
          {
            key: "estbDay",
            fn: function(text, record) {
              return [
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("formatDate")(text)) +
                      "\n      "
                  )
                ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "table-total": _vm.pagination.total > 0,
            "table-total-none": _vm.pagination.total == 0
          },
          staticStyle: { "margin-top": "15px" }
        },
        [
          _vm._v("\n    记录：\n    "),
          _c("span", { staticClass: "text-color-blue" }, [
            _vm._v(" " + _vm._s(_vm.tableData.length) + " 条 ")
          ]),
          _vm._v("\n    祺信金额(元)：\n    "),
          _c("span", { staticClass: "text-color-orange" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm._f("splitK")(_vm.totalPayable(_vm.tableData))) +
                " 元\n    "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          _vm.btns.indexOf("close") > -1
            ? _c(
                "a-button",
                {
                  staticClass: "btn-blue-line",
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_vm._v("取消")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.btns.indexOf("save") > -1
            ? _c("button-load", {
                attrs: { type: "primary", lable: "保存" },
                on: { clickHandle: _vm.save }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.btns.indexOf("save2") > -1
            ? _c("button-load", {
                attrs: { type: "primary", lable: "保存" },
                on: { clickHandle: _vm.handleSave }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0487a722", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0487a722","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bill-manage/payable/invoice-info-dialog.vue
// module id = b77G
// module chunks = 1